export const DEFAULT_EXAMPLE_PROMPT = `<ul>
  <li>basketball game Friday, 5pm, 2 hours. We are on snack duty!</li>
  <li>30-minute check-in with architect on Saturday at 3pm at our house</li>
  <li>Echoing Caves Music Festival, Sun 11am-5pm: Music in acoustic caves.</li>
</ul>`.trim();

export const PLANNER_EXAMPLE_PROMPT =
  "A weekly practice and game schedule for my daughter's soccer team this fall";

// Mirrors the maxLength constraint on CreatePlannerFromPromptInput.prompt.
// Submitting past it fails validation at the gateway, before the resolver runs.
export const PLANNER_PROMPT_MAX_LENGTH = 2000;

export const ACTIONS = {
  changeEmojiMulti: '<p>Update the emojis on all events to be&nbsp;</p>',
  changeEmojiSingle: '<p>Update the emoji to be&nbsp;</p>',
  updateTimeMulti: '<p>Update the time of the earliest event to&nbsp;</p>',
  updateTimeSingle: '<p>Update the time to&nbsp;</p>',
  addLocationMulti: '<p>Set the location on all events to&nbsp;</p>',
  addLocationSingle: '<p>Set the location to&nbsp;</p>',
};
